function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWave15(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ae07fef7-90be-4931-bd6a-70dcd0e25bf5",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1366 48"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "bf33c3e8-df0f-4d35-8614-03f0f900d0e5",
    "data-name": "Wave-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a6915aa0-2cfc-4c1a-beb9-912f242eeef4",
    "data-name": "Rectangle",
    d: "M0,21.49235s90.11805-26.14912,488.53472,6.4481S1366,0,1366,0V47.99986C832.54382,47.99993,533.45618,47.99993,0,48Z",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    }
  })));
}

export default SvgWave15;